import {Condition, EventType} from '../conditions/ConditionsProvider';
import {Symbol} from '../symbols/SymbolProvider';

export type ConditionContextType = {
  condition: Condition | null;
  conditionValue: string | null;
  quantity: number | null;
  conditionQuotes: string[];
  conditionStandardQuotes: string[];
  conditions: Condition[];
  symbolQuotes: object[];
  symbolQuotesStandard: object[];
  eventTypes: EventType[];
  loading: boolean;
  isAutoCorrectionLoading: boolean;
  symbols: Symbol[];
  similarConditions: object[];
  symbol: string | null;
  actionType: number | null;
  orderType: number | null;
  tradingTicketType: number | null;
  tradingTicketTimingType: number | null;
  conditionError: string | null;
  conditionNameError: string | null;
  mark: number | null;
  contingentOrderType: number | null;
  isContingentOrder: boolean;
  isQuantityFromQuote: boolean;
  quantityFromQuote: Quote | null;
  quantityFromQuoteId: string | null;
  quantityFromQuoteField: QuoteField | null;
  quantityFromQuoteFieldId: string | null;
};

export interface ConditionActionsContextType {
  fetchCondition: Function;
  autoCorrectCondition: Function;
  setIsAutoCorrectionLoading: Function;
  setSelectedSymbol: Function;
  setActionType: Function;
  setMark: Function;
  setOrderType: Function;
  setContingentOrderType: Function;
  setIsContingentOrder: Function;
  setIsQuantityFromQuote: Function;
  setQuantityFromQuote: Function;
  setQuantityFromQuoteId: Function;
  setQuantityFromQuoteField: Function;
  setQuantityFromQuoteFieldId: Function;
  setTradingTicketType: Function;
  setTradingTicketTimingType: Function;
  setConditionQuotes: Function;
  setConditionStandardQuotes: Function;
  setConditionValue: Function;
  setConditionError: Function;
  setConditionNameError: Function;
  setQuantity: Function;
  update: Function;
}

export type Quote = {
  id: string;
  label: string;
};

export type QuoteField = {
  id: string;
  key: string;
};

export const MKT_ORDER_TYPE = 1;
export const BID_ORDER_TYPE = 2;
export const ASK_ORDER_TYPE = 3;

export const LIMIT_TRADING_TICKET_TYPE = 1;
export const MARKET_TRADING_TICKET_TYPE = 2;

export const DAY_TRADING_TICKET_TIMING_TYPE = 1;
export const GTC_TRADING_TICKET_TIMING_TYPE = 2;
export const DAY_EXT13_TRADING_TICKET_TIMING_TYPE = 3;
export const GTC_EXT13_TRADING_TICKET_TIMING_TYPE = 4;

export const FLATTEN_QUANTITY = 'Close';

export const ACTION_BUY = 1;
export const ACTION_SELL = 2;

export const CONTINGENT_ORDER_TRAILSTOP = 1;
export const CONTINGENT_ORDER_NONE = 0;
